module.exports = "/dist/c0a555a4f8e997385a3eebbd4da0b9ee.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-500italic.woff2
// module id = 127
// module chunks = 0